var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24803 23.994L17.121 14.121C17.6834 13.5584 17.9994 12.7955 17.9994 12C17.9994 11.2045 17.6834 10.4416 17.121 9.87902L7.25403 0.0120239L5.84003 1.42602L15.707 11.293C15.8945 11.4806 15.9998 11.7349 15.9998 12C15.9998 12.2652 15.8945 12.5195 15.707 12.707L5.83403 22.58L7.24803 23.994Z",
    fill: "#000029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b8154cc7be5240c9aa7b0d84a83fc153.svg";
export { ForwardRef as ReactComponent };